import { useDispatch } from "react-redux";
import { ModalBrandLink } from "../../buttons/buttons";
import { showSideMenu } from "../../../navigation/NavigationActions";
import { PATH } from "../../../onboardingpage/modalview/UserModalController";
import { t } from "../../../i18n";
import { SideMenuComponentsProps } from "./SideMenuComponents";
import { MenuPosition } from "../../../http/protocol";
import { ReactNode } from "react-markdown";
import { OverlayTrigger, Popover } from "react-bootstrap";

export const LoginRegisterAbsolute = () => {
    const dispatch = useDispatch();
    return (
        <div className={"logged-out-items"}>
            <ModalBrandLink
                onClick={() => {
                    dispatch(showSideMenu(false));
                }}
                className={"btn btn-cta full-width register-link"}
                to={PATH.REGISTRATION}
            >
                {t("account.createAccount")}
            </ModalBrandLink>
            <ModalBrandLink
                onClick={() => {
                    dispatch(showSideMenu(false));
                }}
                className={"btn btn-secondary-popup full-width"}
                to={PATH.LOGIN}
            >
                {t("account.login")}
            </ModalBrandLink>
        </div>
    );
};

export const LoginRegisterFixed = (props: SideMenuComponentsProps) => {
    let isAbsolute = props.position == MenuPosition.ABSOLUTE;
    return (
        <div className={`menu-component menu-component-fixed login-register`}>
            <ModalBrandLink
                className={"btn btn-cta full-width register-link fixed-menu-btn"}
                to={PATH.REGISTRATION}
                onClick={() => {
                    if (isAbsolute && props.onClose) {
                        props.onClose();
                    }
                }}
            >
                {t("account.createAccount")}
            </ModalBrandLink>
            <ModalBrandLink
                className={"btn btn-secondary full-width fixed-menu-btn"}
                to={PATH.LOGIN}
                onClick={() => {
                    if (isAbsolute && props.onClose) {
                        props.onClose();
                    }
                }}
            >
                {t("account.login")}
            </ModalBrandLink>
        </div>
    );
};


interface PopOverProps {
    info: string;
    children: ReactNode | ReactNode[];
}

export const CopyPopOver: React.FC<PopOverProps> = (props) => {
    const Text = (
        <Popover placement="top" id="popover-trigger-hover-focus" title="Popover bottom">
            <div className="menu-popover">
                <div className="p-2">
                    <div className="d-flex aling-items-end gap-2">
                        <p className="m-0 p-0 fs-7 text-gray-600 copy-label">{props.info}</p>
                    </div>
                </div>
            </div>
        </Popover>
    );

    return (
        <OverlayTrigger delay={{ show: 300, hide: 300 }} trigger={["hover", "focus"]} placement="right" overlay={Text} container={this}>
            {props.children as JSX.Element}
        </OverlayTrigger>
    );
};